import swal from "sweetalert2";
import React, { useState, useContext, useEffect } from "react";
import DocContext from "./Context/DocContext";
import apiUrl from "../../Constants/api";
import fetchClass from "../shared/httpClass";
// import { Editor } from 'react-draft-wysiwyg';
// import { EditorState, convertToRaw, convertFromHTML } from 'draft-js';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const ComposeMessage = ({ click }) => {
    const url = apiUrl.url;
    const { store } = useContext(DocContext);
    const [message, setMessage] = useState("");
    const [attachment, setAttchment] = useState("");
    const [loading, setLoading] = useState(false);
    const [charCount, setCharCount] = useState(0);

    useEffect(() => {
        // getSponsorChildren();

        setCharCount(message.length);

        return () => "";
    }, [message]);

    const handleChange = e => {
        const value = e.target.value;

        setMessage(value.trim());
    };

    const handleFileChange = e => {
        const value = e.target.files[0];
        setAttchment(value);
    };

    const request = async (endpoint, postdata) => {
        const request = new fetchClass(
            url + endpoint,
            "POST",
            postdata,
            "form-data"
        );

        setLoading(true);
        const response = await request.http();
        setLoading(false);

        return response;
    };

    function handleClick() {
        setLoading(true);

        let fd = new FormData();
        fd.append("photo", attachment);
        fd.append("child_id", store.child.child_id);
        fd.append("message", message);

        request("sendletter", fd).then(res => {
            setLoading(false);

            if (!res.status) {
                showAlert().then(result => {
                    if (result.value) {
                        window.location.href = "/dashboard/letters";
                    }
                });
            }
        });
    }

    function showAlert() {
        return swal.fire(
            "Success",
            "You have successfully sent your message.",
            "success"
        );
    }

    return (
        <div className="compose-message">
            <div className="row">
                <div className="col-sm-11">
                    <p>
                        Your sponsored child will feel thrilled and delighted
                        when they feel your love and support in a message
                        directly from you. Write them a message today, and let
                        them know they're in your thoughts and prayers.
                    </p>
                </div>

                <div className="col-sm-1 text-center">
                    <button
                        disabled={loading}
                        className="btn-close"
                        onClick={click}
                    >
                        <i className="fas fa-times" />
                    </button>
                </div>
            </div>

            <p className="char-count">{"character count: " + charCount}</p>

            <textarea
                onChange={handleChange}
                defaultValue={message}
                disabled={loading}
                className="form-control form-group"
                rows="13"
            />
            {/* 
            <Editor
                editorState={ message }
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName="form-control form-group"
                onEditorStateChange={ handleChange }
            /> */}

            <div className="row">
                <div className="col-sm-8 text-right">
                    <p style={{ color: "#ff921e" }}>
                        Allowed file types: jpg,jpeg,png,gif
                    </p>
                    <p style={{ color: "#ff921e" }}>
                        Allowed max file size: 8mb
                    </p>
                </div>
                <div className="col-sm-4 text-right">
                    <input
                        type="file"
                        className="file-button"
                        name="photo"
                        onChange={handleFileChange}
                    />
                    <button
                        disabled={loading}
                        className="btn btn-primary"
                        onClick={handleClick}
                    >
                        Send message
                    </button>
                </div>
            </div>

            {/* <p className="text-right">
                <input
                    type="file"
                    className="file-button"
                    name="photo"
                    onChange={handleFileChange}
                />
                <button
                    disabled={loading}
                    className="btn btn-primary"
                    onClick={handleClick}
                >
                    Send message
                </button>
            </p> */}
        </div>
    );
};

export default ComposeMessage;
